import { useLocation, Link } from "react-router-dom";
import { Lock, ShieldCheck } from "lucide-react";
import { BRAND } from "@/lib/constants";

export default function AdminLogin() {
  const location = useLocation();
  const error = location.state?.error;

  const onSignIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="flex min-h-screen flex-col bg-[#F8FAFC]">
      <header className="border-b border-[#E2E8F0] bg-white">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
          <Link to="/" data-testid="admin-login-home-link" className="flex items-center gap-3">
            <img src={BRAND.logos.primecore} alt="PrimeCore" className="h-9 w-auto" />
            <span className="hidden h-6 w-px bg-[#E2E8F0] sm:inline-block" />
            <span className="hidden text-sm font-semibold tracking-wide text-[#2E3744] sm:inline-block">Q-Wis Admin</span>
          </Link>
          <Link to="/" className="text-sm text-[#475569] hover:text-[#0A1128]">← Back to site</Link>
        </div>
      </header>

      <main className="flex flex-1 items-center justify-center px-4 py-16">
        <div className="w-full max-w-md rounded-lg border border-[#E2E8F0] bg-white p-10 shadow-sm">
          <div className="flex h-12 w-12 items-center justify-center rounded-md bg-[#0A1128] text-white">
            <Lock size={20} />
          </div>
          <h1 className="mt-6 font-serif-display text-3xl text-[#0A1128]">Admin Sign-in</h1>
          <p className="mt-2 text-sm text-[#475569]">
            Restricted to authorized PrimeCore administrators only.
          </p>

          {error && (
            <div data-testid="admin-login-error" className="mt-5 rounded-md border border-red-200 bg-red-50 p-3 text-sm text-red-700">
              {error}
            </div>
          )}

          <button
            data-testid="admin-google-signin"
            onClick={onSignIn}
            className="mt-7 flex w-full items-center justify-center gap-3 rounded-md bg-[#0A1128] px-5 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-[#13204A]"
          >
            <GoogleIcon /> Continue with Google
          </button>

          <div className="mt-7 flex items-start gap-3 rounded-md bg-[#F8FAFC] p-4 text-xs text-[#475569]">
            <ShieldCheck size={16} className="mt-0.5 shrink-0 text-[#E8772E]" />
            <span>
              Only the email addresses on the PrimeCore admin allowlist are
              permitted. Other Google accounts will be rejected.
            </span>
          </div>
        </div>
      </main>
    </div>
  );
}

function GoogleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
      <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.4 29.3 35.5 24 35.5c-6.4 0-11.5-5.1-11.5-11.5S17.6 12.5 24 12.5c2.9 0 5.5 1.1 7.5 2.8l5.7-5.7C33.6 6.3 29 4.5 24 4.5 13.2 4.5 4.5 13.2 4.5 24S13.2 43.5 24 43.5c10.7 0 19.5-8.7 19.5-19.5 0-1.2-.1-2.3-.4-3.5z"/>
      <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 16 19 12.5 24 12.5c2.9 0 5.5 1.1 7.5 2.8l5.7-5.7C33.6 6.3 29 4.5 24 4.5 16.3 4.5 9.7 8.7 6.3 14.7z"/>
      <path fill="#4CAF50" d="M24 43.5c5 0 9.6-1.7 13.1-4.6l-6-5C29 35.5 26.6 36.5 24 36.5c-5.3 0-9.7-3.1-11.3-7.5l-6.5 5C9.6 39.7 16.3 43.5 24 43.5z"/>
      <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.4 4.3-4.5 5.7l6 5C40.7 35.7 43.5 30.4 43.5 24c0-1.2-.1-2.3-.4-3.5z"/>
    </svg>
  );
}
